<div class="row">

    <input matInput placeholder="Enter your awards and accolades" #awardInput [formControl]="awardsCtrl"
        (keyup.enter)="enterAward($event)"><button mat-button color="primary" (click)="enterAward($event)">Add</button>
</div>
<div class="row">
    <mat-list role="list">
        <mat-list-item role="listitem" *ngFor="let award of awards">{{award}} <i class="fas fa-trash-alt"
                (click)="removeAward(award)"></i>
        </mat-list-item>
    </mat-list>
</div>